import React, { FC } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation } from 'react-router-dom'

// Styles
import { AppBar, Theme, Toolbar, makeStyles, Grid, Link, IconButton } from '@material-ui/core'

// Images
import { GameFlowSteps } from 'types'
import { ReactComponent as Logo } from 'assets/verizon-logo.svg'
import { menuDrawerOpen, toggleDrawer } from 'redux/menu'
import { MenuIcon } from './MenuIcon'

interface HeaderProps {
  preventFade?: boolean
  setActiveTab?: (state: GameFlowSteps) => void
}

interface StyleProps {
  preventFade?: boolean
}

export const Header: FC<HeaderProps> = ({ children, preventFade, setActiveTab }) => {
  const classes = useStyles({ preventFade: !!preventFade })
  const dispatch = useDispatch()
  const drawerOpen = useSelector(menuDrawerOpen)
  const handleToggleDrawer = () => dispatch(toggleDrawer(!drawerOpen))
  const location = useLocation()

  return (
    <AppBar className={classes.root} position='relative'>
      <Toolbar disableGutters className={classes.toolbar}>
        <Grid container justify='space-between'>
          <Grid item>
            <Link onClick={() => (setActiveTab ? setActiveTab(GameFlowSteps.Welcome) : false)}>
              <Logo className={classes.logo} />
            </Link>
          </Grid>
          {children}
        </Grid>
        {location.pathname.match(/event/) ? (
          <IconButton className={classes.button} color='default' aria-label='menu' onClick={handleToggleDrawer}>
            <MenuIcon opened={drawerOpen} />
          </IconButton>
        ) : null}
      </Toolbar>
    </AppBar>
  )
}

const fadeInAnimationConfig = {
  animationName: '$fadeInOpacity',
  animationIterationCount: 1,
  animationTimingFunction: 'ease-in',
  animationDuration: '0.75s'
}

const useStyles = makeStyles<Theme, StyleProps>((theme: Theme) => ({
  root: ({ preventFade }) => ({
    position: 'absolute',
    top: 0,
    left: 0,
    width: 'calc(100% - 64px)',
    backgroundColor: 'transparent',
    padding: '3rem 5% 1rem',
    boxShadow: 'unset',
    'z-index': '1200',
    opacity: 1,
    ...(preventFade ? {} : fadeInAnimationConfig),
    [theme.breakpoints.down('md')]: {
      paddingTop: '2rem'
    },
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      backgroundColor: theme.palette.common.white,
      boxShadow: 'inset 0 -1px 0 #D8DADA',
      height: 52,
      padding: '0 2rem',
      zIndex: 1300
    }
  }),
  '@keyframes fadeInOpacity': {
    '0%': {
      opacity: 0
    },
    '100%': {
      opacity: 1
    }
  },
  toolbar: {
    flexGrow: 1,
    justifyContent: 'space-between',
    minHeight: 'unset',

    [theme.breakpoints.down('xs')]: {
      minHeight: 'unset'
    }
  },
  logo: {
    [theme.breakpoints.up('sm')]: {
      position: 'relative',
      height: 40,
      width: 150
    },
    [theme.breakpoints.down('xs')]: {
      width: 102,
      height: 26,
      display: 'block'
    }
  },
  button: {
    display: 'none',
    padding: '9px',

    [theme.breakpoints.down('sm')]: {
      display: 'block'
    }
  }
}))
